import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const COOKIE_KEY = 'astroa2z_cookie_consent';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_KEY, JSON.stringify({ essential: true, analytics: true, preferences: true, ts: Date.now() }));
    setVisible(false);
  };

  const acceptEssential = () => {
    localStorage.setItem(COOKIE_KEY, JSON.stringify({ essential: true, analytics: false, preferences: false, ts: Date.now() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent-banner" style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 9999,
      background: '#1a1a2e', color: '#eee', padding: '1.2rem 2rem',
      boxShadow: '0 -2px 16px rgba(0,0,0,0.3)', display: 'flex',
      flexWrap: 'wrap', alignItems: 'center', gap: '1rem', justifyContent: 'space-between'
    }}>
      <div style={{ flex: '1 1 400px', fontSize: '0.9rem', lineHeight: 1.6 }}>
        <strong>🍪 We use cookies</strong> to provide essential functionality, remember your preferences,
        and understand how you use our platform. By clicking "Accept All", you consent to all cookies.
        See our <Link to="/privacy-policy" style={{ color: '#f9a825' }}>Privacy Policy</Link> for details.
      </div>
      <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
        <button onClick={acceptEssential} style={{
          padding: '0.6rem 1.2rem', border: '1px solid #888', borderRadius: '6px',
          background: 'transparent', color: '#eee', cursor: 'pointer', fontSize: '0.85rem'
        }}>
          Essential Only
        </button>
        <button onClick={accept} style={{
          padding: '0.6rem 1.2rem', border: 'none', borderRadius: '6px',
          background: '#f9a825', color: '#1a1a2e', cursor: 'pointer', fontWeight: 600, fontSize: '0.85rem'
        }}>
          Accept All
        </button>
      </div>
    </div>
  );
}
